module.exports = __webpack_public_path__ + "img/buy-btn.f0dda887.png";